import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import {
  Select,
  Modal,
  Checkbox,
  Upload,
  message,
  Image,
  Radio,
  Spin , 
  Table
} from "antd";
import { PlusOutlined, CopyOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import Api from "../../services/ServiceApi";
import { changeLang } from "../../actions/langAction";
import moment from "moment";
import Map from "../../ui/map/assign_job";
import ModalSuccess from "../../components/Modal_Success";
import reqwest from "reqwest";
import { Link } from "react-router-dom";
class InformDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "INFORM PROBLEM",
      tab: [{ text: "All Asset" }],
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      current_option: 1,
      columns: [
        {
          title: "Inform No.",
          dataIndex: "asset_id",
          key: "asset_id",
          render: (item) => (
            <Link to="/full_detail_job" className="c-blue text-underline">
              {item}
            </Link>
          ),
          sorter: (a, b) => a.asset_id - b.asset_id,
        },
        {
          title: "Asset ID",
          dataIndex: "group_type_name",
          key: "group_type_name",
          sorter: (a, b) => a.group_type_name.length - b.group_type_name.length,
        },
        {
          title: "Area Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
        {
          title: "Location Name",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
          sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        },
        {
          title: "Inform Date",
          dataIndex: "asset_sub_type_name",
          key: "asset_sub_type_name",
          sorter: (a, b) =>
            a.asset_sub_type_name.length - b.asset_sub_type_name.length,
        },
        {
          title: "Inform Detail",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
        },
        {
          title: "Inform By",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
        },
      ],
      data: [],
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      location_lat: "-",
      location_lon: "-",
      location_name: "-",
      ass_code: "-",
      smart_code: "-",
      fileList: [],
      set_asset: [],
      inform_detail: "",
      form: {},
      factcheck: false,
      modalstatus: false,
      btnName: "",
      urlpath: "",
      status_cancel: false,
      maseter_reject: [],
      ma_period: "-",
      text_modal: "",
      data_inform:
        JSON.parse(localStorage.getItem("informDetail")) === null
          ? []
          : JSON.parse(localStorage.getItem("informDetail")),
      set_pic: [],
      job_cat: [],
      job_type: [],
      customs: {
        select_object_path: null,
        select_sel_type: null,
        select_new_type: null,
        select_sub_category: null,
      },
      sub_type: [],
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
      data_translate: [],
      Priority: 1,
      setBtn: false,
      masterData: [],
      selected_subtype: null,
      selected_jobtype: null,
      checkAssetType : true , 
      wfId : 0  ,
      columns_job_history: [
        {
          title: "Job no",
          dataIndex: "job_no",
          key: "job_no",
          sorter: (a, b) => a.job_no.length - b.job_no.length,
        },
        {
          title: "Asset id",
          dataIndex: "asset_id",
          key: "asset_id",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.asset_id.length - b.asset_id.length,
        },
        {
          title: "Emp Inform Date",
          dataIndex: "emp_inform_date",
          key: "emp_inform_date",
          render: (item) => {
              return !item
                ? "-"
                : moment(item).format("DD/MM/YYYY HH:mm");
          },
          sorter: (a, b) => a.emp_inform_date.length - b.emp_inform_date.length,
        },
        {
          title: "Inform Detail",
          dataIndex: "inform_detail",
          key: "inform_detail",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.inform_detail.length - b.inform_detail.length,
        },
        {
          title: "From Main Process Name",
          dataIndex: "from_main_process_name",
          key: "from_main_process_name",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.from_main_process_name.length - b.from_main_process_name.length,
        },
        {
          title: "Finish Date",
          dataIndex: "finish_date",
          key: "finish_date",
          render: (item) => {
            return !item
            ? "-"
            : moment(item).format("DD/MM/YYYY HH:mm");
          },
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
      ],
      job_history : []
    };
  }
  async componentDidMount() {
    document.title = this.state.title;
    const informDetail = JSON.parse(localStorage.getItem("informDetail"));
    Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: null,
    })
      .then((response) => {
        const result = response.data.data.result_data.filter(
          (data) => data.job_category_name === "Claim"
        );
        this.setState({
          job_cat: result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          data_translate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factupdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    if (process.env.NODE_ENV === "development") {
      this.setState({
        urlpath: process.env.REACT_APP_URL_API,
      });
    } else {
      this.setState({
        urlpath: process.env.REACT_APP_URL_API,
      });
    }
    if (JSON.parse(localStorage.getItem("informDetail")) != null) {
      Api.post("v2/get_cdi_new_smart", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        v_where: "and asset_id = '" + informDetail.asset_id + "'",
      })
        .then((response) => {
          this.setState({
            inform_detail: informDetail.inform_detail,
            btnName: "Create Job",
          });
          this.onChangeasset(true, response.data.data.result[0]);
        })
        .catch((e) => {
          console.log(e);
        });
      const fullDetail = await Api.post("v2/tab_list_inform_fulldetail", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        inform_job_id: this.state.data_inform.inform_job_id,
        asset_id: this.state.data_inform.asset_id,
        asset_no: this.state.data_inform.asset_code,
      });

      for (let i = 0; i < fullDetail.data.data.result_pic.length; i++) {
        this.state.fileList.push({
          uid: i,
          name: fullDetail.data.data.result_pic[i].pic_upload_name,
          status: "done",
          url: Api.checkPath(
            fullDetail.data.data.result_pic[i].pic_url_path,
            fullDetail.data.data.result_pic[i].pic_upload_name
          ),
        });
      }
      const selectReject = await Api.post("get_servicemareasonstoptime_v2", {
        company_id: Cookies.get("company_id"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        ma_reason: "REJECT",
      });

      Api.post("V4/get_job_type", {
        pk_id: null,
        fk_id: 1,
        is_active: "1",
        effective: "1",
        sql_where: null,
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        UserName: Cookies.get("username"),
      })
        .then(async (response) => {
          this.setState({
            job_type: response.data.data,
          });

          if (fullDetail.data.data.result_inform[0].job_type_id !== null) {
            this.Setdata_jobtype(
              fullDetail.data.data.result_inform[0].job_type_id,
              response.data.data
            );
            var service_type_level_id =
              fullDetail.data.data.result_inform[0].service_type_level_id;
            await this.handleproblem(
              "objectpart",
              service_type_level_id.substring(0, 2) + "000000",
              null,
              null,
              null
            );
            await this.handleproblem(
              "servicetype",
              service_type_level_id.substring(0, 2) +
                service_type_level_id.substring(2, 4) +
                "0000",
              null,
              null,
              null
            );
            await this.handleproblem(
              "new_type",
              service_type_level_id.substring(0, 2) +
                service_type_level_id.substring(2, 4) +
                service_type_level_id.substring(4, 6) +
                "00",
              null,
              null,
              null
            );
            this.handleproblem(
              "sub_category",
              service_type_level_id,
              null,
              null,
              null
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });

      this.setState({
        maseter_reject: selectReject.data.data.serult_service_reason,
        set_pic: fullDetail.data.data.result_pic,
        masterData: fullDetail.data.data.result_inform,
        selected_jobtype: !fullDetail.data.data.result_inform[0].job_type_id
          ? ""
          : fullDetail.data.data.result_inform[0].job_type_id,
        selected_subtype: !fullDetail.data.data.result_inform[0].job_sub_type_id
          ? ""
          : fullDetail.data.data.result_inform[0].job_sub_type_id,
        Priority: parseInt(
          fullDetail.data.data.result_inform[0].priority_level
        ),
        factcheck: true,
      });
    } else {
      Api.get(
        "get_cdi_new_smart",
        Cookies.get("companyid") + "/" + Cookies.get("operator_id") + "/"
      )
        .then((response) => {
          this.setState({
            set_asset: response.data.data.data,
            btnName: "Create Inform",
            factcheck: true,
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }

    this.btnjobDetail(1, "add");
  }
  checkAsset = (e) => {
    this.setState({
      ckasset: e.target.checked,
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      ass_lat: "",
      ass_long: "",
      ass_name: "",
      ass_code: "",
      asset_id: "",
      area_id: "",
      sub_area_id: "",
      customs: {
        select_object_path: null,
      },
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,

      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
    });

    if(e.target.checked){
      this.loadDataJobHistory("-1")
    }else{
      this.setState({
        job_history : []
      })
    }
  };
  handleInputChange = (event) => {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;

    form[name] = value;
  };
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
  };
  handleChange = ({ fileList }) => this.setState({ fileList });
  handleCancel = () => this.setState({ previewVisible: false });
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };
  onChangeasset = (check, obj) => {
    const filter_objectPath = this.state.ObjectPart.filter(
      (data) => data.service_desc === obj.obj.asset_type_name
    );
    const filter_jobtype = this.state.job_type.filter(
      (data_jobtype) =>
        parseInt(data_jobtype.job_type_id) ===
        parseInt(this.state.selected_jobtype)
    );

    if (check === true) {
      this.setState({
        asset_name: obj.asset_name === null ? "-" : obj.asset_name,
        group_type: obj.group_type_name === null ? "-" : obj.group_type_name,
        asset_type: obj.asset_type_name === null ? "-" : obj.asset_type_name,
        ass_sub_type:
          obj.asset_sub_type_name === null ? "-" : obj.asset_sub_type_name,
        modal_number: obj.model_no === null ? "-" : obj.model_no,
        serial_number: obj.serial_no === null ? "-" : obj.serial_no,
        date_install: obj.install_date === null ? "-" : obj.install_date,
        warranty: obj.warranty_expire === null ? "-" : obj.warranty_expire,
        location_lat: obj.location_lat === null ? "-" : obj.location_lat,
        location_lon: obj.location_lon === null ? "-" : obj.location_lon,
        location_name: obj.location_name === null ? "-" : obj.location_name,
        ass_code: obj.asset_code === null ? "-" : obj.asset_code,
        area_id: obj.area_id === null ? "-" : obj.area_id,
        asset_id: obj.asset_id === null ? "-" : obj.asset_id,
        sub_area_id: obj.sub_area_id === null ? "-" : obj.sub_area_id,
        ma_period: obj.ma_period === null ? "-" : obj.ma_period,
        // asset_ma: obj.obj.name,
      });
    } else {
      this.setState({
        asset_name: obj.obj.asset_name === null ? "-" : obj.obj.asset_name,
        group_type:
          obj.obj.group_type_name === null ? "-" : obj.obj.group_type_name,
        asset_type:
          obj.obj.asset_type_name === null ? "-" : obj.obj.asset_type_name,
        ass_sub_type:
          obj.obj.asset_sub_type_name === null
            ? "-"
            : obj.obj.asset_sub_type_name,
        modal_number: obj.obj.model_no === null ? "-" : obj.obj.model_no,
        serial_number: obj.obj.serial_no === null ? "-" : obj.obj.serial_no,
        date_install:
          obj.obj.install_date === null ? "-" : obj.obj.install_date,
        warranty:
          obj.obj.warranty_expire === null ? "-" : obj.obj.warranty_expire,
        location_lat:
          obj.obj.location_lat === null ? "-" : obj.obj.location_lat,
        location_lon:
          obj.obj.location_lon === null ? "-" : obj.obj.location_lon,
        location_name:
          obj.obj.location_name === null ? "-" : obj.obj.location_name,
        ass_code: obj.obj.asset_code === null ? "-" : obj.obj.asset_code,
        area_id: obj.obj.area_id === null ? "-" : obj.obj.area_id,
        asset_id: obj.obj.asset_id === null ? "-" : obj.obj.asset_id,
        sub_area_id: obj.obj.sub_area_id === null ? "-" : obj.obj.sub_area_id,
        ma_period: obj.obj.ma_period === null ? "-" : obj.obj.ma_period,

        // asset_ma: obj.obj.name,
      });

      if (this.state.ObjectPart.length > 0) {
        if (filter_objectPath.length === 0) {
          this.setState({
            customs: {
              select_object_path:
                this.state.ObjectPart[0].service_type_level_id,
            },
            checkAssetType: true,
          });
          this.handleproblem(
            "objectpart",
            this.state.ObjectPart[0].service_type_level_id
          );
        } else {
          this.handleproblem(
            "objectpart",
            filter_objectPath[0].service_type_level_id,
            "Add Asset",
            filter_jobtype[0].job_type_name,
            [obj.obj]
          );
          this.setState({
            customs: {
              select_object_path: filter_objectPath[0].service_type_level_id,
            },
          });
        }
      }
    }

    this.loadDataJobHistory(obj.children);

  };
  CreateJob = async () => {
    this.setState({
      factcheck: false
    })
    if (this.state.btnName === "Create Job") {
      setTimeout(function () {
        localStorage.setItem("StatusLocal", 2);
        window.location.assign("/MaxiOperation/editjob");
      }, 1000);
    } else {
      const { fileList } = this.state;
      const formData = new FormData();
      const Dataset = {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        asset_id: this.state.asset_id === "" ? "-1" : this.state.asset_id,
        asset_code: this.state.ass_code,
        location_name:
          this.state.location_name === "-" ? "" : this.state.location_name,
        location_lon:
          this.state.location_lon === "-" ? "" : this.state.location_lon,
        location_lat:
          this.state.location_lat === "-" ? "" : this.state.location_lat,
        create_by: Cookies.get("username"),
        inform_detail: this.state.form["inform_detail"],
        priority_level: this.state.Priority,
        job_category_id: this.state.jobcategory,
        job_type_id: this.state.selected_jobtype,
        job_sub_type_id: this.state.selected_subtype,
        service_type_level_id: this.state.service_type_level_id,
        job_sla_id: this.state.sla_id,
        wf_id: this.state.wfId
      };
      const createjob = await Api.post("tab_create_inform_V3", Dataset);
      if (createjob.data.result.code === "P") {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach((file) => {
          formData.append("files", file["originFileObj"]);
          formData.append("create_by", Cookies.get("username"));
          formData.append("company_id", Cookies.get("companyid"));
          formData.append("project_id", Cookies.get("project_id"));
          formData.append("project_id", Cookies.get("project_id"));
          formData.append("asset_id", this.state.asset_id);
          formData.append(
            "inform_job_id",
            createjob.data.data.result_data[0].infrom_job_id
          );
          formData.append("operator_id", Cookies.get("operator_id"));
        });
        if (fileList.length > 0) {
          reqwest({
            url: this.state.urlpath + "tab_inform_savefile/",
            method: "post",
            headers: { TokenUser: Cookies.get(`OperationToken`) },
            processData: false,
            data: formData,
            success: () => {
              this.setState({
                factcheck: true
              })
              this.setState({
                fileList: [],
                uploading: false,
                text_modal: "Create Inform",
                modalstatus: true,
              });
              message.success("upload successfully.");
            },
            error: () => {
              this.setState({
                uploading: false,
              });
              message.error("upload failed.");
            },
          });
        } else {
          this.setState({
            factcheck: true
          })
          this.setState({
            text_modal: "Create Inform",
            modalstatus: true,
          });
        }
      }
    }
  };
  CancelInform = async () => {
    const cancelInform = await Api.post("tab_update_inform_approve", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      inform_job_id: this.state.data_inform.inform_job_id,
      flag_approve: 2,
      create_by: Cookies.get("username"),
      service_ma_reason_id: this.state.form["Reason"],
      approve_remark: this.state.form["remark"],
    });
    if (cancelInform.data.result.code === "P") {
      this.setState({
        text_modal: "Cancel Inform",
        modalstatus: true,
      });
    }
  };
  onApprove = async () => {
    const tab_update_inform_approve = await Api.post(
      "tab_update_inform_approve",
      {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        inform_job_id: JSON.parse(localStorage.getItem("informDetail"))
          .inform_job_id,
        flag_approve: 1,
        create_by: Cookies.get("userId"),
      }
    );
    if (tab_update_inform_approve.data.result.code === "P") {
      this.setState({
        text_modal: "Approve Inform",
        modalstatus: true,
      });
    } else {
      alert("Approve ไม่สำเร็จ");
    }
  };
  async btnjobDetail(n, status) {
    this.setState({
      setBtn: !this.state.setBtn,
    });

    if (!this.state.setBtn) {
      Api.post("V4/get_job_type", {
        pk_id: null,
        fk_id: n,
        is_active: "1",
        effective: "1",
        sql_where: null,
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        UserName: Cookies.get("username"),
      })
        .then((response) => {
          this.setState({
            selected_jobtype: "",
            selected_subtype: "",
            sub_type: [],
            jobcategory: n,
            job_type: response.data.data,
            //set_asset: []
            customs: {
              select_object_path: null,
            },
            sel_type: null,
            sel_new_type: null,
            sel_sub_cat: null,
            ObjectPart: [],
            serviceType: [],
            newType: [],
            subCategory: [],
            sla_level: [],
            std_hour: "",
            std_day: "",
            std_minute: "",
            sla_id: "",
            sel_sla: null,
          });
          // this.Setdata_jobtype(null);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      this.setState({
        // selected_jobtype: null,
        // selected_subtype: null,
        sub_type: [],
        jobcategory: n,
        job_type: [],
        //set_asset: []
        customs: {
          select_object_path: null,
        },
        sel_type: null,
        sel_new_type: null,
        sel_sub_cat: null,
        ObjectPart: [],
        serviceType: [],
        newType: [],
        subCategory: [],
        sla_level: [],
        std_hour: "",
        std_day: "",
        std_minute: "",
        sla_id: "",
        sel_sla: null,
      });
    }
  }
  onChange = (e) => {
    this.setState({
      Priority: e.target.value,
    });
  };
  async Setdata_jobtype(value, data) {
    const checkwf = (data === undefined ? this.state.job_type : data).find(
      (element) => parseInt(element.job_type_id) === parseInt(value)
    );
    if (checkwf.wf_id === null) {
      this.setState({
        checkbtn: false,
      });
    } else {
      Api.post("getButtonDetailWeb", {
        WF_ID: checkwf.wf_id,
        CompanyID: Cookies.get("companyid"),
        ProjectID: Cookies.get("project_id"),
        JobTypeID: value,
        Version: 1,
        MainProcessID: "0",
        SubProcessID: "-1",
        ActionID: 1,
        UserName: Cookies.get("username"),
        operator_id: Cookies.get("operator_id"),
      })
        .then((response) => {
          if (
            response.data.return_nextWorkFlow.length === 0 ||
            response.data.return_nextWorkFlow === null
          ) {
            this.setState({
              wfId:  checkwf.wf_id, 
              checkbtn: false,
              status_button_workflow: "กรุณาตรวจสอบการเลือก Job Type !!",
            });
          } else {
            this.setState({
              wfId:  checkwf.wf_id, 
              checkbtn: true,
              WorkFlow: response.data.return_nextWorkFlow,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      // sql_where: null,
    })
      .then((response) => {
        const result = response.data.data.job_sub_type_dto_list.filter(
          (data) => data.job_check_list_type != "PLN"
        );
        this.setState({
          selected_jobtype: value || null,
          selected_subtype: result[0].job_sub_type_id,
          sub_type: result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    Api.post("get_service_type_ma_list_each_level", {
      company_id: Cookies.get("companyid"),
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      service_lv1: null,
      service_lv2: null,
      service_lv3: null,
      service_lv4: null,
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        this.setState({
          ObjectPart: response.data.data.result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    this.setState({
      customs: {
        select_object_path: null,
      },
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
      disabledAddAsset: true,
    });
  }
  handleproblem = async (name, value, status, jobtype_name, data) => {
    switch (name) {
      case "objectpart":
        this.setState({
          customs: {
            select_object_path: value,
          },
        });
        Api.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: null,
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.setState({
              service_type_level_id: value.substring(0, 2),
              serviceType: response.data.data.result,
              sel_type:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              sel_new_type: null,
              sel_sub_cat: null,
              newType: [],
              subCategory: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "servicetype",
                response.data.data.result[0].service_type_level_id
              );
            }
            if (status === "Add Asset") {
              const filter_service_type = this.state.serviceType.filter(
                (data) => data.service_desc === jobtype_name
              );
              if (filter_service_type.length === 0) {
                this.setState({
                  asset_list: data,
                  visible_addasset: false,
                  checkAssetType: true,
                });
              } else {
                this.setState({
                  sel_type: filter_service_type[0].service_type_level_id,
                  asset_list: data,
                  visible_addasset: false,
                  checkAssetType: true,
                });
                if (
                  this.state.jobcategory === 1 ||
                  this.state.jobcategory === "1"
                ) {
                  Api.post("get_job_sla_special", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    job_category_id: this.state.jobcategory,
                    job_type_id: this.state.selected_jobtype,
                    job_sub_type_id: 0,
                    service_type_level_id: null,
                    v_where:
                      " and service_type_level_id like concat('" +
                      filter_service_type[0].service_type_level_id.substring(
                        0,
                        4
                      ) +
                      "','%')",
                  })
                    .then((result_sub_category) => {
                
                      this.setState({
                        service_type_level_id: data[0].service_type_level_id,
                        subCategory: result_sub_category.data.data.result,
                        asset_list: data,
                        visible_addasset: false,
                        checkAssetType: false,
                      });
                      if(result_sub_category.data.data.result.length === 1){
                        this.handleproblem("sub_category", result_sub_category.data.data.result[0].service_type_level_id)
                      }
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                }
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "servicetype":
        Api.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.setState({
              service_type_level_id:
                this.state.service_type_level_id + value.substring(2, 4),
              sel_type: value,
              newType: response.data.data.result,
              sel_new_type:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              subCategory: [],
              // sla_level: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "new_type",
                response.data.data.result[0].service_type_level_id
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "new_type":
        Api.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: value.substring(4, 6),
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.setState({
              sel_new_type: value,
              service_type_level_id: value,
              subCategory: response.data.data.result,
              sel_sub_cat:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "sub_category",
                response.data.data.result[0].service_type_level_id
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "sub_category":
        if (this.state.checkAssetType === true) {
          const get_job_sla = await Api.post("get_job_sla", {
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            job_sub_type_id: 0,
            service_type_level_id: value,
          });

          this.setState({
            service_type_level_id: value,
            sla_level: get_job_sla.data.data.result,
            sel_sub_cat: value,
            sel_sla: get_job_sla.data.data.result[0].job_sla_id,
            std_hour: get_job_sla.data.data.result[0].sla_time_hour,
            std_day:
              get_job_sla.data.data.result[0].sla_time_day === null
                ? 0
                : get_job_sla.data.data.result[0].sla_time_day,
            std_minute:
              get_job_sla.data.data.result[0].sla_time_min === null
                ? 0
                : get_job_sla.data.data.result[0].sla_time_min,
            sla_id: get_job_sla.data.data.result[0].job_sla_id,
          });
        } else {
          const filter_subcat = this.state.subCategory.filter(
            (data) => data.service_type_level_id === value
          );
          this.setState({
            service_type_level_id: value,
            sel_new_type: value,
            newType: filter_subcat,
            sel_sub_cat: value,
            sla_level: filter_subcat,
            sel_sla: filter_subcat[0].job_sla_id,
            std_hour: filter_subcat[0].sla_time_hour,
            std_day: filter_subcat[0].sla_time_day,
            std_minute: filter_subcat[0].sla_time_min,
            sla_id: value,
          });
        }
        break;
      case "sla":
        this.setState({
          std_hour: "",
          std_day: "",
          std_minute: "",
          sla_id: "",
        });
        this.setState({
          sel_sla: value,
          std_hour: this.state.sla_level[0].sla_time_hour,
          std_day: this.state.sla_level[0].sla_time_day,
          std_minute: this.state.sla_level[0].sla_time_min,
          sla_id: value,
          service_type_level_id: this.state.sla_level[0].service_type_level_id,
        });
        break;
      default:
        return null;
    }
  };
  loadDataJobHistory = (value) => {
    Api.post("checklistjobasset", {
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id"),
      "asset_id": value,
      "job_category_id": this.state.jobcategory
    })
      .then((response) => {
        this.setState({
          job_history : response.data.data.result_oper_job
        })
      })
      .catch((e) => {
        console.log(e);
      });
  }
  render() {
    const { title, fileList } = this.state;
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const job_cat_btn = this.state.job_cat.map((job_cat, index) => {
      let thismr = "";
      if ((index + 1) % 5 == 0 && index != 0) {
        thismr = "mr-2 ";
      }
      return (
        <div
          key={index + 54547}
          // className={ thismr + "p0"}
          style={{ marginBottom: "10px", width: "200px", marginLeft: "36%" }}
        >
          <button
            type="button"
            className={
              this.state.jobcategory == job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            onClick={this.btnjobDetail.bind(this, job_cat.job_category_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={
                this.state.setBtn
                  ? Api.absoluteUrl("/icon/job_show.svg")
                  : Api.absoluteUrl("/icon/job_dis.svg")
              }
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={Api.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <LayoutOperation active={3}>
        {this.state.modalstatus ? (
          <ModalSuccess
            status={this.state.text_modal}
            path_location="/MaxiOperation/inform_problem_list"
          />
        ) : null}
          <>
               <Spin spinning={!this.state.factcheck} size="large" style={{marginTop: "16%"}}>
            <div className="wrapper-header d-flex align-items-center">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-3">
                    <img
                      src={Api.absoluteUrl("/icon/asset_list_white.svg")}
                      className="mr-3"
                    />
                    <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                      {title}
                    </h2>
                  </div>
                  <div className="col-5">
                    <div className="row justify-content-center">
                      <div className="col-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="font-thai-b c-white font14"></span>
                        </div>
                      </div>
                      <div className="col-3 offset-1">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="font-thai-b c-white font14"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 text-right">
                    <button
                      // className="btn btn-secondary"
                      className={
                        localStorage.getItem("active") === "1" ||
                        localStorage.getItem("active") === "2"
                          ? "btn btn-warning divshow mr-2"
                          : "btn btn-warning divhide"
                      }
                      style={{
                        color: "#000f9f",
                        background: "#DEDEDE",
                        border: "1px solid #DEDEDE",
                      }}
                      // className="btn btn-success mr-2 divshow"
                      onClick={() => this.setState({ status_cancel: true })}
                    >
                      Cancel
                    </button>
                    <button
                      className={
                        localStorage.getItem("active") === "1"
                          ? "btn btn-success   divshow"
                          : "divhide"
                      }
                      // className={
                      //   this.state.check_approve
                      //     ? "btn btn-success mr-2 divshow"
                      //     : " btn btn-success mr-2 divhide"
                      // }
                      // className="btn btn-success mr-2 divshow"
                      onClick={() => this.onApprove()}
                    >
                      <img
                        src={Api.absoluteUrl("/icon/approve.svg")}
                        className="mr-2"
                      />
                      Approve
                    </button>
                    <button
                      className={
                        localStorage.getItem("active") === "0" ||
                        localStorage.getItem("active") === "1" ||
                        localStorage.getItem("active") === "2"
                          ? "btn btn-warning ml-2 divshow"
                          : "divhide"
                      }
                      // className="btn btn-danger mr-2 divshow"
                      onClick={() => this.CreateJob()}
                    >
                      {/* Create Job */}
                      {this.state.btnName}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrapper-body"
              // style={{ backgroundColor: "#E8ECEF" }}
            >
              <div
                className="card"
                style={{
                  marginRight: "10%",
                  marginLeft: "10%",
                  marginTop: "1%",
                }}
              >
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={Api.absoluteUrl("/icon/setting.svg")}
                      />
                      <span className="jobdetail">Job Detail</span>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-2"></div>
                    <div className="col-10">
                      <div className="row">
                        <div className="col-12">{job_cat_btn}</div>
                        <div className="col-6 mt-4">
                          <label
                            className="labeaddjob"
                            style={{ fontSize: "14px" }}
                          >
                            {"Job Type"}
                          </label>
                          <br />
                          <Select
                            style={{ width: "80%" }}
                            value={this.state.selected_jobtype}
                            className="dropdrowtype"
                            onChange={(value) => this.Setdata_jobtype(value)}
                          >
                            <Select value="" disabled>
                              Please select
                            </Select>
                            {this.state.job_type.map((item, index) => (
                              <Select key={index} value={item.job_type_id}>
                                {item.job_type_name}
                              </Select>
                            ))}
                          </Select>
                        </div>
                        <div className="col-6  mt-4">
                          <label
                            className="labeaddjob"
                            style={{ fontSize: "14px" }}
                          >
                            {"Job Sub Type"}
                            {/* <b style={{ color: "#DF4547" }}> * </b>{" "} */}
                          </label>
                          <br />
                          <Select
                            style={{ width: "80%" }}
                            value={this.state.selected_subtype}
                            className="dropdrowtype"
                            onChange={(value) => this.Setdata_jobtype(value)}
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.sub_type.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.job_sub_type_id}
                              >
                                {item.job_type_name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mt-3"
                style={{
                  marginRight: "10%",
                  marginLeft: "10%",
                  marginTop: "1%",
                }}
              >
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-2"> </div>
                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={Api.absoluteUrl("/icon/Asset.svg")}
                      />
                      <span className="jobdetail">Asset Detail</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col-4" style={{ margin: "auto" }}>
                          {this.state.btnName === "Create Job" ? null : (
                            <Checkbox
                              onChange={this.checkAsset}
                              checked={this.state.ckasset}
                              style={{ fontSize: "20px", color: "#0500A3" }}
                            >
                              <label className="labelheader">No Asset</label>
                            </Checkbox>
                          )}
                          <div
                            className={
                              this.state.ckasset ? "divhide" : "divshow"
                            }
                          >
                            <label className="labeaddjob mt-4">
                              Asset Code <b style={{ color: "#DF4547" }}> * </b>
                            </label>{" "}
                            <br />{" "}
                            {this.state.status_cookie === 1 ? (
                              <input
                                type="text"
                                className="inputfile"
                                style={{ width: "100%" }}
                                name="location_name"
                                disabled={
                                  this.state.ckasset === true ? "" : "disabled"
                                }
                                value={this.state.asset_code}
                              ></input>
                            ) : (
                              <Select
                                showSearch
                                style={{ border: "0px", width: "100%" }}
                                placeholder="Select a  Asset Code"
                                className="inputfile"
                                onChange={this.onChangeasset}
                                optionFilterProp="children"
                                disabled={
                                  this.state.btnName === "Create Job"
                                    ? true
                                    : false
                                }
                                filterOption={(input, option) =>
                                  option.children === "" ||
                                  option.children === null
                                    ? null
                                    : option.children
                                        .toLowerCase()
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                value={this.state.ass_code}
                              >
                                {this.state.set_asset.map((item, index) => (
                                  <Select.Option
                                    value={item.ma_skill_id}
                                    key={index}
                                    obj={item}
                                  >
                                    {item.asset_code}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </div>
                        </div>
                        <div
                          className={
                            this.state.ckasset == true
                              ? "col-6 divhide"
                              : "col-6 divshow"
                          }
                          style={{ margin: "auto" }}
                        >
                          <div className="row">
                            <div className="col-4">
                              <label className="labelheader">
                                {"Asset Name"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.asset_name}
                              </label>
                            </div>

                            <div className="col-4">
                              <label className="labelheader">
                                {"Group Type"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.group_type}
                              </label>
                            </div>

                            <div className="col-4">
                              <label className="labelheader">
                                {"Asset Type"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.asset_type}
                              </label>
                            </div>

                            <div className="col-4">
                              <label className="labelheader">
                                {"Asset Sub Type"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.ass_sub_type}
                              </label>
                            </div>
                            <div className="col-4">
                              <label className="labelheader">
                                {"Model Number"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.modal_number}
                              </label>
                            </div>
                            <div className="col-4">
                              <label className="labelheader">
                                {"Serial Number"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.serial_number}
                              </label>
                            </div>

                            <div className="col-4">
                              <label className="labelheader">
                                {"Date Install"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {moment(this.state.date_install).format(
                                  "D MMMM YYYY"
                                ) === "Invalid date"
                                  ? "-"
                                  : moment(this.state.date_install).format(
                                      "D MMMM YYYY"
                                    )}
                              </label>
                            </div>
                            <div className="col-4">
                              <label className="labelheader">
                                {"Warranty"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.warranty}
                              </label>
                            </div>
                            <div className="col-4">
                              <label className="labelheader">
                                {"Ma Period"}
                              </label>
                            </div>
                            <div className="col-6">
                              <label className="labelddetail">
                                {this.state.asset_ma}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
      className="card mt-3"
      style={{
        marginRight: "10%",
        marginLeft: "10%",
        marginTop: "1%",
      }}
            >
              <div className="card-body">
                <div
                  className="mt-2"
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                          width: "20px"
                        }}
                        src={Api.absoluteUrl("/icon/database.svg")}
                      />
                      <span className="jobdetail font-thai-b">
                        {"Job History"}
                      </span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <Table
                        size="middle"
                        rowKey=""
                        columns={this.state.columns_job_history}
                        dataSource={this.state.job_history}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

              <div
                className="card mt-3"
                style={{ marginRight: "10%", marginLeft: "10%" }}
              >
                <div className="card-body">
                  <div className="mt-2">
                    <div className="row mt-3">
                      <div className="col-2"> </div>

                      <div className="col-10">
                        <img
                          style={{
                            float: "left",
                            marginTop: "7px",
                            marginRight: "10px",
                          }}
                          src={Api.absoluteUrl("/icon/location.svg")}
                        />
                        <span className="jobdetail">{"Location"}</span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-5 mt-3">
                            <label className="labeaddjob">Location Name</label>
                            <br />{" "}
                            <input
                              type="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="location_name"
                              onChange={(e) => this.handleInputChange(e)}
                              disabled={
                                this.state.ckasset == true ? "" : "disabled"
                              }
                              value={this.state.location_name}
                            ></input>
                            <br />
                            <div className="row">
                              <div className="col-6 mt-2">
                                <label className="labeaddjob">
                                  Location Lat
                                </label>
                                <br />
                                <input
                                  type="text"
                                  className="inputfile"
                                  style={{ width: "100%" }}
                                  name="location_lat"
                                  onChange={(e) => this.handleInputChange(e)}
                                  disabled={
                                    this.state.ckasset == true ? "" : "disabled"
                                  }
                                  //   value={this.state.location_lat}
                                  value={this.state.location_lat}
                                ></input>
                              </div>
                              <div className="col-6 mt-2">
                                <label className="labeaddjob">
                                  Location Long
                                </label>
                                <br />
                                <input
                                  type="text"
                                  className="inputfile"
                                  style={{ width: "100%" }}
                                  name="location_lon"
                                  onChange={(e) => this.handleInputChange(e)}
                                  disabled={
                                    this.state.ckasset == true ? "" : "disabled"
                                  }
                                  value={this.state.location_lon}
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-4 ml-4 mt-3"
                            style={{ height: "200px" }}
                          >
                            <Map
                              data={{
                                location_lat:
                                  this.state.location_lat === "-" ||
                                  this.state.location_lat === ""
                                    ? 13.8638
                                    : this.state.location_lat,
                                location_lon:
                                  this.state.location_lon === "-" ||
                                  this.state.location_lon === ""
                                    ? 100.5998
                                    : this.state.location_lon,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mt-3"
                style={{ marginRight: "10%", marginLeft: "10%" }}
              >
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={Api.absoluteUrl("/icon/Asset.svg")}
                      />
                      <span className="jobdetail">Problem Detail</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <label className="labeaddjob">Inform Detail</label>
                      <br />{" "}
                      <textarea
                        style={{ width: "100%", height: "80px" }}
                        disabled={
                          localStorage.getItem("active") === "0" ||
                          localStorage.getItem("active") === 0
                            ? false
                            : true
                        }
                        name="inform_detail"
                        defaultValue={this.state.inform_detail}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["object_part"]
                              }{" "}
                              {/* <b style={{ color: "#DF4547" }}>*</b> */}
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            className="dropdrowtype"
                            onChange={(value) =>
                              this.handleproblem("objectpart", value)
                            }
                            value={this.state.customs.select_object_path || ""}
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.ObjectPart.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_obj_part === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              {" "}
                              กรุณาเลือก Object Part{" "}
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-6">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["service_type"]
                              }{" "}
                              {/* <b style={{ color: "#DF4547" }}>*</b> */}
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            onChange={(value) =>
                              this.handleproblem("servicetype", value)
                            }
                            value={this.state.sel_type || ""}
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.serviceType.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_service_type === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              {" "}
                              กรุณาเลือก Service Type{" "}
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["category_type"]
                              }{" "}
                              {/* <b style={{ color: "#DF4547" }}>*</b> */}
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            value={this.state.sel_new_type || ""}
                            onChange={(value) =>
                              this.handleproblem("new_type", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.newType.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc === undefined
                                  ? item.service_LV3_name
                                  : item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_new_type === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              {" "}
                              กรุณาเลือก Service Type{" "}
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-6">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["sub_category"]
                              }{" "}
                              {/* <b style={{ color: "#DF4547" }}>*</b> */}
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            className="dropdrowtype"
                            value={this.state.sel_sub_cat || ""}
                            onChange={(value) =>
                              this.handleproblem("sub_category", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.subCategory.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc === undefined
                                  ? item.service_LV4_name
                                  : item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_sub_cat === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              {" "}
                              กรุณาเลือก Sub Category{" "}
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-3">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["sla_level"]
                              }{" "}
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            value={this.state.sel_sla || ""}
                            onChange={(value) =>
                              this.handleproblem("sla", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.sla_level.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.job_sla_id}
                              >
                                {item.sla_name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <div className="col-3">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_day"]
                              }{" "}
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.std_day}
                          ></input>
                        </div>
                        <div className="col-3">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_hour"]
                              }{" "}
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.std_hour}
                          ></input>
                        </div>
                        <div className="col-3">
                          {" "}
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_minute"]
                              }{" "}
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.std_minute}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6 divhide">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["inform_name"]
                              }
                            </label>
                          ) : null}
                          <br />{" "}
                          <input
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            onChange={this.handleInputChange}
                            // value={this.state.inform_name}
                          ></input>
                          <br />{" "}
                        </div>
                        <div className="col-12">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["priority"]
                              }
                            </label>
                          ) : null}
                          {/* <br /> */}
                          <Radio.Group
                            onChange={this.onChange}
                            value={this.state.Priority}
                          >
                            <Radio value={3} className="ml-5">
                              {" "}
                              <img
                                src={Api.absoluteUrl("/icon/high.svg")}
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                                className="mr-2"
                              />{" "}
                            </Radio>
                            {/* <br /> */}
                            <Radio value={2} className="mt-2">
                              {" "}
                              <img
                                src={Api.absoluteUrl("/icon/normal.svg")}
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                                className="mr-2"
                              />
                            </Radio>
                            {/* <br /> */}
                            <Radio value={1} className="mt-2">
                              {" "}
                              <img
                                src={Api.absoluteUrl("/icon/low.svg")}
                                className="mr-2"
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                              />
                            </Radio>
                          </Radio.Group>{" "}
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        Cookies.get("companyid") === "1"
                          ? "col-2 divhide"
                          : "col-2 divshow"
                      }
                      style={{ textAlign: "center" }}
                    >
                      <button
                        type="button"
                        style={{ marginTop: "60%" }}
                        className="c-blue text-underline"
                        onClick={() => this.onMoreDetail()}
                      >
                        More detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mt-3"
                style={{ marginRight: "10%", marginLeft: "10%" }}
              >
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-2"> </div>
                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={Api.absoluteUrl("/icon/Asset.svg")}
                      />
                      <span className="jobdetail">Attachment</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div
                      className="col-12 mt-3"
                      style={{ textAlign: "center" }}
                    >
                      {JSON.parse(localStorage.getItem("active")) === 0 ? (
                        <Upload
                          action={
                            process.env.REACT_APP_URL_API + "mockupupload/"
                          }
                          multiple={true}
                          listType="picture-card"
                          fileList={fileList}
                          onPreview={this.handlePreview}
                          onChange={this.handleChange}
                          height={"20%"}
                        >
                          {this.state.btnName === "Create Job"
                            ? null
                            : fileList.length >= 8
                            ? null
                            : uploadButton}
                        </Upload>
                      ) : (
                        <div className="row mt-2">
                          <div className="col-3"></div>
                          <div className="col-9">
                            <div className="row">
                              {this.state.set_pic.map((data, index) => {
                                return (
                                  <>
                                    {(data.pic_upload_type.toLowerCase() ===
                                      ".jpg" ||
                                      data.pic_upload_type.toLowerCase() ===
                                        ".png" ||
                                      data.pic_upload_type.toLowerCase() ===
                                        ".jpeg" ||
                                      data.pic_upload_type.toLowerCase() ===
                                        ".svg") &&
                                    data.pic_type === "N" ? (
                                      <div class="col-auto mb-1">
                                        <Image
                                          className="ml-1"
                                          style={{ cursor: "pointer" }}
                                          width={150}
                                          height={80}
                                          src={Api.checkPath(
                                            data.pic_url_path,
                                            data.pic_upload_name
                                          )}
                                        />
                                      </div>
                                    ) : (data.pic_upload_type.toLowerCase() ===
                                        ".mp4" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".avi" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".mov" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".wmv") &&
                                      data.pic_type === "N" ? (
                                      <div class="col-auto mb-1">
                                        <video
                                          width="150"
                                          controls
                                          className="ml-1  mr-1"
                                          style={{ height: "80px" }}
                                        >
                                          <source
                                            src={Api.checkPath(
                                              data.pic_url_path,
                                              data.pic_upload_name
                                            )}
                                            type="video/mp4"
                                          ></source>
                                        </video>
                                      </div>
                                    ) : (data.pic_upload_type.toLowerCase() ===
                                        ".pdf" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".xlsx" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".xls" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".doc" ||
                                        data.pic_upload_type.toLowerCase() ===
                                          ".txt") &&
                                      data.pic_type === "N" ? (
                                      <div class="col-auto">
                                        <a
                                          href={Api.checkPath(
                                            data.pic_url_path,
                                            data.pic_upload_name
                                          )}
                                          download
                                        >
                                          <CopyOutlined
                                            style={{ marginRight: "5px" }}
                                          />

                                          {data.pic_upload_name}
                                        </a>
                                      </div>
                                    ) : null}
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                      <Modal
                        visible={this.state.previewVisible}
                        title={this.state.previewTitle}
                        footer={null}
                        onCancel={this.handleCancel}
                      >
                        <img
                          alt="example"
                          style={{ width: "100%" }}
                          src={this.state.previewImage}
                        />
                      </Modal>
                    </div>
                  </div>
                </div>
                {/* ==========================  Location Name ================================ */}
              </div>
              <br />
            </div>
            </Spin>
            <Modal
              title={null}
              centered
              visible={this.state.status_cancel}
              footer={null}
              closable={true}
              onCancel={() =>
                this.setState({
                  status_cancel: false,
                })
              }
            >
              <div className="text-center">
                <h3 className="font-mont-sb font18 c-blue mt-3">Cancel Job</h3>
                <div className="row mt-3 mb-2">
                  <div className="col-3">
                    {" "}
                    <span>Reason : </span>
                  </div>
                  <div className="col-7">
                    <Select
                      style={{ border: "0px", textAlign: "left" }}
                      placeholder="Select a Reason"
                      className="inputfile"
                      onChange={(value) => (this.state.form["Reason"] = value)}
                    >
                      {this.state.maseter_reject.map((item, index) => (
                        <Select.Option
                          value={item.service_ma_reason_id}
                          key={index}
                        >
                          {item.service_ma_reason_desc}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-3">
                    {" "}
                    <span>Remark : </span>
                  </div>
                  <div className="col-7">
                    <textarea
                      style={{ width: "100%", height: "60px" }}
                      name="inform_remark"
                      onChange={(e) =>
                        (this.state.form["remark"] = e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
                <button
                  onClick={() => this.CancelInform()}
                  className="btn btn-secondary"
                >
                  OK
                </button>
              </div>
            </Modal>
          </>
    
      </LayoutOperation>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(InformDetail);
